export const checkDesksBusyCodes = {
  notBusy: 1, // Столы не задействованы в настроенные дни
};
